<template>
  <PanelGroup
    class="rounded-lg"
    style="height: 600px"
  >
    <template #left>
      <FlexPanel
        :open="leftPanelTwoOpen"
        location="left"
        width="200px"
        class="bg-yellow-100"
      >
        <span class="uppercase font-bold">Flex Left</span>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
      </FlexPanel>
      <FlexPanel
        :open="leftPanelOpen"
        location="left"
        width="400px"
        class="bg-green-200"
      >
        <div class="p-8">
          <span class="uppercase font-bold">Flex Left</span>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
            deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
            saepe suscipit.
          </p>
        </div>
      </FlexPanel>
      <FloatPanel
        :open="floatLeftPanelOpen"
        location="left"
        width="35%"
        class="bg-green-200"
      >
        test float left
        <button
          @click="floatLeftPanelOpen = !floatLeftPanelOpen"
          class="border bg-green-400 px-2 py-1 rounded block"
        >
          Close
        </button>
      </FloatPanel>
    </template>

    <template #right>
      <FlexPanel
        :open="rightPanelOpen"
        location="right"
        width="35%"
        class="bg-green-200"
        >test right</FlexPanel
      >
      <FloatPanel
        :open="floatRightPanelOpen"
        location="right"
        width="15%"
        class="bg-gray-400 shadow-xl border border-gray-400 p-8"
      >
        <span class="uppercase font-bold">Float Right</span>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
      </FloatPanel>
    </template>

    <template #top>
      <FlexPanel
        :open="topPanelOpen"
        location="top"
        height="200px"
        class="bg-gray-400 shadow-inner"
        >test top</FlexPanel
      >
      <FloatPanel
        :open="floatTopPanelOpen"
        location="top"
        height="200px"
        class="bg-blue-200 border-gray-800 shadow-lg"
        >test top panel float</FloatPanel
      >
    </template>

    <template #bottom>
      <FlexPanel
        :open="bottomPanelOpen"
        location="bottom"
        height="200px"
        class="bg-red-200"
        >test bottom</FlexPanel
      >
      <FloatPanel
        :open="floatBottomPanelOpen"
        location="bottom"
        height="75%"
        class="bg-blue-200 border-gray-800 shadow-lg"
      >
        test float bottom
        <button
          @click="floatBottomPanelOpen = !floatBottomPanelOpen"
          class="border bg-green-400 px-2 py-1 rounded block"
        >
          CLOSE bottom panel
        </button>
      </FloatPanel>
    </template>

    <div class="bg-blue-50 w-full pb-12 overflow-y-scroll">
      <div class="py-12 px-4">
        <div class="flex gap-x-2 pt-6">
          <button
            @click="leftPanelOpen = !leftPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open left panel
          </button>
          <button
            @click="leftPanelTwoOpen = !leftPanelTwoOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open left panel Two
          </button>
          <button
            @click="rightPanelOpen = !rightPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open right panel
          </button>
          <button
            @click="bottomPanelOpen = !bottomPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open bottom panel
          </button>
          <button
            @click="topPanelOpen = !topPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open top panel
          </button>
        </div>

        <div class="flex gap-x-2 pt-6">
          <button
            @click="floatTopPanelOpen = !floatTopPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open top panel
          </button>
          <button
            @click="floatBottomPanelOpen = !floatBottomPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open bottom panel
          </button>
          <button
            @click="floatLeftPanelOpen = !floatLeftPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open left panel
          </button>
          <button
            @click="floatRightPanelOpen = !floatRightPanelOpen"
            class="border bg-green-400 px-2 py-1 rounded block"
          >
            open right panel
          </button>
        </div>
      </div>

      <div class="">
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
        <p class="py-2 px-4">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam autem consequatur, delectus
          deleniti doloremque ducimus explicabo fuga harum id incidunt maxime nobis officia qui, quidem, quisquam quos
          saepe suscipit.
        </p>
      </div>
    </div>
  </PanelGroup>
</template>
<script setup>
import { ref } from 'vue'
import { PanelGroup, FloatPanel, FlexPanel } from '@/Components/Panels'

const leftPanelOpen = ref(false)
const leftPanelTwoOpen = ref(false)
const rightPanelOpen = ref(false)
const bottomPanelOpen = ref(false)
const topPanelOpen = ref(false)
const floatLeftPanelOpen = ref(false)
const floatLeftPanelTwoOpen = ref(false)
const floatRightPanelOpen = ref(false)
const floatBottomPanelOpen = ref(false)
const floatTopPanelOpen = ref(false)
</script>
